import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "withRouter";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";

import {
  PageWrapper,
  CheckWrapper,
  Check,
  Text,
  H1,
  TextContainer,
  StyledLink,
  A,
} from "./styledComponents";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Spinner from "components/Spinner";
import {
  selectVerificationResultPending,
  selectEmailConfirmed,
} from "../SelfSignUp/selectors";
import { verifyEmailRequest } from "./actions";

class ConfirmEmailPage extends Component {


  componentDidMount() {
    const token = this.props.params.token.split("=")[1];
    this.props.verifyEmail(token);
  }

  componentDidUpdate(prevProps) {

    if (this.props.emailConfirmed === true) {
      setTimeout(() => {
        //redirect to sign in page
        this.props.navigate("/sign-in");
      }, 4000);
    }
  }

  render() {
    const { verificationPending, emailConfirmed } = this.props;
    return (
      <PageWrapper>
        <HelmetProvider>
          <Helmet title="Movebooth | Verification" />
        </HelmetProvider>
        {verificationPending ? (
          <Spinner />
        ) : emailConfirmed && !verificationPending ? (
          <div>
            <CheckWrapper>
              <svg
                width="200"
                height="200"
                viewBox="0 0 82 82"
                xmlns="http://www.w3.org/2000/svg"
              >
                <Check
                  fill="none"
                  strokeWidth="4"
                  d="M 29 41 l 8.1 7.2 16.7-16.8"
                />
              </svg>
            </CheckWrapper>

            <TextContainer>
              <H1>Your account has been verified</H1>
              <Text>
                Taking you back to sign in now.
                <br />
                If you aren't redirected with 5 seconds, please{" "}
                <Link to="/sign-in">
                  <StyledLink>click here</StyledLink>
                </Link>
              </Text>
            </TextContainer>
          </div>
        ) : (
          <TextContainer>
            <H1>uh oh!</H1>
            <Text>
              This verification link is expired or invalid. Please request a new
              one by{" "}
              <Link to="/sign-in">
                <StyledLink>signing in with your account</StyledLink>
              </Link>
              .
            </Text>
            <Text extraStyle="margin-top: 1em;">
              If this problem persists, please{" "}
              <A
                target="_blank"
                rel="noreferrer noopener"
                name="Help"
                href="https://help.mvbth.com"
              >
                contact us
              </A>
              .
            </Text>
          </TextContainer>
        )}
      </PageWrapper>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  verificationPending: selectVerificationResultPending(),
  emailConfirmed: selectEmailConfirmed(),
});

const mapDispatchToProps = (dispatch) => ({
  verifyEmail: (token) => dispatch(verifyEmailRequest(token)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ConfirmEmailPage));
